<template>
  <div>
    <div @click="navigateToAccountView()" style="cursor: pointer;">
      <b-icon icon="chevron-left" class="mt-3"></b-icon>&nbsp;Zurück
    </div>

    <b-alert variant="warning" show class="text-center mt-4">
      <div>
        <b-icon
          icon="exclamation-triangle"
          font-scale="1.5"
        ></b-icon>
        <br />
        Du befindest dich im <strong>Administratorbereich</strong>.
        Bitte beachte, dass Änderungen in diesem Bereich erhebliche
        Auswirkungen auf das System und die Benutzer haben können.
      </div>
    </b-alert>

    <b-card header="Administration" class="mt-3">
      <b-list-group>
        <b-list-group-item href="#" @click="navigateTo('new-user')">Benutzer erstellen&nbsp;<b-icon icon="chevron-right"></b-icon></b-list-group-item>
        <b-list-group-item href="#" disabled><b-icon icon="slash-circle"></b-icon>&nbsp;Benutzer bearbeiten&nbsp;<b-icon icon="chevron-right"></b-icon></b-list-group-item>
        <b-list-group-item href="#" @click="navigateTo('new-news')">Neuigkeit erstellen&nbsp;<b-icon icon="chevron-right"></b-icon></b-list-group-item>
        <b-list-group-item href="#" @click="action('delete-news')">Neuigkeit löschen&nbsp;<b-icon icon="chevron-right"></b-icon></b-list-group-item>
        <b-list-group-item href="#" @click="navigateTo('new-attendance')">Termin erstellen&nbsp;<b-icon icon="chevron-right"></b-icon></b-list-group-item>
        <b-list-group-item href="#" disabled><b-icon icon="slash-circle"></b-icon>&nbsp;Termin bearbeiten&nbsp;<b-icon icon="chevron-right"></b-icon></b-list-group-item>
        <b-list-group-item href="#" @click="navigateTo('new-guestflight')">Gastflug erstellen&nbsp;<b-icon icon="chevron-right"></b-icon></b-list-group-item>
      </b-list-group>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "adminView",
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
    };
  },
  methods: {
    navigateToAccountView() {
      this.$router.push(`/account`);
    },

    navigateTo(page) {
      this.$router.push(`/account/admin/${page}`);
    },

    action(action) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      
      if (action === "delete-news") {
        this.$swal.fire({
          title: "Achtung!",
          text: "Möchtest du diese Neuigkeit wirklich löschen?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#dc3545",
          confirmButtonText: "Ja, löschen",
          cancelButtonText: "Abbrechen",
          }).then((result) => {
            if (result.isConfirmed) {
              axios
                .delete(this.apiUrl + "/account/admin/delete-news")
                .then(() => {
                  Toast.fire({
                    icon: "success",
                    title: "Neuigkeit gelöscht",
                    text: "Die Neuigkeit wurde gelöscht.",
                  });
                })
                .catch((error) => {
                  console.error("Error fetching data:", error);

                  if (error.status === 401) {
                    localStorage.removeItem("token");
                  }
                });
            }
          });
      }
    }
  },
};
</script>

<style scoped></style>
